export enum UserPlan {
    FREE = 1,
    PAID = 2,
}